// extracted by mini-css-extract-plugin
export default {"pageContainer":"HomePage_pageContainer__id+IN","title":"HomePage_title__ygULj"};